module.exports = __webpack_public_path__ + "static/media/bullhorn.b8eec134.svg";